"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBettingCreateSession = void 0;
var keys_1 = require("../keys");
var react_1 = require("react");
var useMutation_1 = require("../useMutation");
var useBettingCreateSession = function (_a) {
    var _b = _a === void 0 ? {} : _a, successAction = _b.successAction, errorAction = _b.errorAction;
    var _c = (0, useMutation_1.useMutation)({
        successAction: successAction,
        errorAction: function (err) {
            errorAction === null || errorAction === void 0 ? void 0 : errorAction();
        },
        path: keys_1.BETTING_SESSION_CREATE,
    }), mutate = _c.mutate, isSubmitting = _c.isSubmitting, error = _c.error, data = _c.data;
    return (0, react_1.useMemo)(function () { return ({
        createBettingSession: function (payload) { return mutate(payload); },
        isSubmitting: isSubmitting,
        error: error === null || error === void 0 ? void 0 : error['errorCode'],
        data: data,
    }); }, [mutate, isSubmitting, error, data]);
};
exports.useBettingCreateSession = useBettingCreateSession;
